import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Bell, BellOff, Globe } from 'lucide-react';
import { useWebPush } from '@/hooks/useWebPush';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const WebPushSettings = () => {
  const { isSupported, isSubscribed, subscribe, unsubscribe } = useWebPush();

  if (!isSupported) {
    return (
      <Alert>
        <Globe className="h-4 w-4" />
        <AlertDescription>
          Web push notifications are not supported in your browser. 
          Try using Chrome, Firefox, or Edge for the best experience.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          {isSubscribed ? <Bell className="h-5 w-5" /> : <BellOff className="h-5 w-5" />}
          <CardTitle>Browser Push Notifications</CardTitle>
        </div>
        <CardDescription>
          Receive notifications directly in your browser, even when Therappi® is not open
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="web-push">Enable browser notifications</Label>
            <p className="text-sm text-muted-foreground">
              Get insights, reminders, and updates in your browser
            </p>
          </div>
          <Switch
            id="web-push"
            checked={isSubscribed}
            onCheckedChange={(checked) => {
              if (checked) {
                subscribe();
              } else {
                unsubscribe();
              }
            }}
          />
        </div>

        {isSubscribed && (
          <Alert className="bg-green-500/10 border-green-500/20">
            <Bell className="h-4 w-4 text-green-500" />
            <AlertDescription className="text-green-500">
              Browser notifications are active. You'll receive notifications even when Therappi® is closed.
            </AlertDescription>
          </Alert>
        )}

        {!isSubscribed && (
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              To enable browser notifications:
            </p>
            <ol className="text-sm text-muted-foreground list-decimal list-inside space-y-1">
              <li>Click the toggle above</li>
              <li>Allow notifications when prompted</li>
              <li>Notifications will work across all your devices</li>
            </ol>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
